import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./ResourceCategory.css"

export const ResourceCategory = () => {
  return (
        <>
        <RoutingMenu activeScreen="resourceCategory" />
    <div className=''>

        <iframe
            src={`${config.RootUrl}/faculty/library/resourceCategory/resourceCategoryHTML.php?isIframe=true`}
            className="iframe col-md-12"
        >
        </iframe>
    </div>
    </>
  )
}
